import React, { MutableRefObject, useRef, memo } from "react";
import RedliningMap, { HOLCGrade } from "./RedliningMap";

interface Props {
  selectionMap: MutableRefObject<Record<string, HOLCGrade>>;
}

const Redlining: React.FC<Props> = ({ selectionMap }) => {
  return (
    <div className="redlining-maps-container">
      <RedliningMap selectionMap={selectionMap} />
    </div>
  );
};

export default Redlining;
